import { Component, Input, Type, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { IUser } from '@interfaces/user.interface';
import { AuthService } from '@services/auth.service';
import { ModalUpdatePasswordComponent } from '@shared/modals/modal-update-password/modal-update-password.component';
import { ModalUserAccountSettingsComponent } from '@shared/modals/modal-user-account-settings/modal-user-account-settings.component';
import { UserAvatarComponent } from '@shared/user-avatar/user-avatar.component';
import { DropdownPanelComponent, IDropdownPanel, ModalComponentBase, ModalService } from 'ngx-lib';

@Component({
    selector: 'app-user-panel',
    templateUrl: './user-panel.component.html',
    styleUrls: ['./user-panel.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DropdownPanelComponent, UserAvatarComponent]
})
export class UserPanelComponent {
    @Input()
    user?: IUser;

    @Input()
    showSubheading?: boolean;

    panel: IDropdownPanel;

    constructor(
        private readonly router: Router,
        private readonly modalService: ModalService,
        private readonly authService: AuthService
    ) {
        this.showSubheading = true;
        this.panel = {
            items: [
                {
                    id: 'account-settings',
                    name: 'Account Settings',
                    action: () => this.openModal(ModalUserAccountSettingsComponent)
                },
                {
                    id: 'edit-notifications',
                    name: 'Notification Settings',
                    action: () => this.editNotifications()
                },
                {
                    id: 'update-password',
                    name: 'Update Password',
                    action: () => this.openModal(ModalUpdatePasswordComponent)
                },
                {
                    id: 'logout',
                    name: 'Log Out',
                    action: () => this.logout()
                }
            ]
        };
    }

    openModal<TParameters, TResult>(type: Type<ModalComponentBase<TParameters, TResult | undefined>>) {
        this.modalService.open(type);
    }

    logout() {
        this.authService.logout();
    }

    editNotifications() {
        this.router.navigate(['/notifications-edit']);
    }
}
